import React, { useEffect, useState } from "react";
import { List, ListItem, CircularProgress } from "@mui/material";
import { SelectedAddressProps } from "../../../Interface/scheduler/form";
import { isInvalidZipcode } from "../Helper/Helper";
import fetchDetails from "../../../utility/fetchPropertyDetails";
import { useFormContext } from "../../contexts/FormContext";
import { useFormConfigContext } from "../../contexts/FormConfigContext";
import { conceptCodes } from "../../../constants/constant";
import "./AddressDropdown.css";

interface AddressDropdownProps {
  apiResults: { title?: string; address: SelectedAddressProps }[];
  onSelect: (selectedAddress: SelectedAddressProps) => void;
  isLoading: boolean;
}

let topSuggestedAddress: string;
let topSuggestedAddressDetails: string;

const suggestedAddressSelected = false;

let topSuggestedHouseNo: string;
let topSuggestedStreetName: string;
let topSuggestedBuilding: string;
let topSuggestedCity: string;
let topSuggestedState: string;

export const getTopSuggestedAddress = () => topSuggestedAddress;
export const gettopSuggestedAddressDetails = () => topSuggestedAddressDetails;

export const getSuggestedAddressSelected = () => suggestedAddressSelected;

const AddressDropdown: React.FC<AddressDropdownProps> = ({
  apiResults,
  onSelect,
  isLoading,
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const { formValues, setFormValues } = useFormContext();
  const { formConfig } = useFormConfigContext();

  const fetchCleaningPropertyDetails = (selectedAddress) => {
    const zipcode = { zipcode: formValues.zipcode };
    const addressFormValues = { ...selectedAddress, ...zipcode };
    fetchDetails(addressFormValues, setFormValues, formConfig, () => {});
  };

  const handleSelect = (selectedAddress: SelectedAddressProps, title?: string) => {
    const addressWithTitle = { ...selectedAddress, title };
    onSelect(addressWithTitle);
    setIsVisible(false);
    if (
      formConfig?.conceptCode === conceptCodes.MLY_CONCEPT_CODE &&
      formConfig?.steps[0]?.fetchAttomData
    ) {
      fetchCleaningPropertyDetails(selectedAddress);
    }
    sessionStorage.setItem("selectedAddressFromDropdown", "true");
  };

  useEffect(() => {
    if (apiResults?.length > 0) {
      const firstAddress = apiResults[0]?.address;

      topSuggestedAddress = firstAddress?.label;
      topSuggestedHouseNo = firstAddress?.houseNumber ?? "";
      topSuggestedStreetName = firstAddress?.street ?? "";
      topSuggestedBuilding = firstAddress?.building ?? "";
      topSuggestedState = firstAddress?.state ?? "";
      topSuggestedCity = firstAddress?.city ?? "";
    }

    topSuggestedAddressDetails =
      `${topSuggestedHouseNo} ${topSuggestedStreetName} ${topSuggestedBuilding} ${topSuggestedCity} ${topSuggestedState}`.trim();
  }, [apiResults]);

  if (isLoading) {
    return (
      <div className="loading-indicator" aria-busy="true" aria-live="polite">
        <CircularProgress />
      </div>
    );
  }

  if (!isVisible) {
    return null;
  }

  return (
    <List className="address-dropdown" aria-label="Address suggestions">
      {apiResults
        .filter(
          (result) =>
            result?.address?.label && !isInvalidZipcode(result?.address?.label),
        )
        .map((result, index) => (
          <ListItem key={index} onClick={() => handleSelect(result?.address, result?.title)}>
            {result?.address?.label}
          </ListItem>
        ))}
    </List>
  );
};

export default React.memo(AddressDropdown);
